// @flow
import * as React from 'react';

import AdminAutoMessageSftpCredentialsContainer from './AdminAutoMessageSftpCredentialsContainer.jsx';
import AdminAutoMessageSftpCredentialsView from './AdminAutoMessageSftpCredentialsView.jsx';

type Props = {
  organizationUUID: string,
};

export default class AdminAutoMessageSftpCredentials extends React.Component<Props, *> {
  render() {
    const { organizationUUID } = this.props;

    return (
      <AdminAutoMessageSftpCredentialsContainer organizationUUID={organizationUUID}>
        {props => (
          <AdminAutoMessageSftpCredentialsView {...props} organizationUUID={organizationUUID} />
        )}
      </AdminAutoMessageSftpCredentialsContainer>
    );
  }
}
